module.exports = {"title":"Interview Braambos","date":"2015-02-10T00:00:00Z","layout":"post","attachment":"ibr.mp3","linktext":"Beluister interview","body":"<p><strong>Interview met Sylvain De Bleeckere</strong> over het boek <strong>Levensbeschouwing democratisch belicht</strong>. uitgezonden door <strong>Braambos</strong> op 10.02.2015, naar aanleiding van de <em>24ste editie van De Dag van de Religieuze Film</em>.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/2015-01-09-InterviewBraambos/index.md
// module id = 971
// module chunks = 0